import React from 'react';
import _get from 'lodash/get';
import classnames from 'classnames';

const ConcernMaskEffect = ({
  activeDetection,
  transformedSequenceOfCategory,
  detectionMapping,
  isHd,
  isLandscape,
}) => {
  const getImageStyle = value => ({
    ..._get(detectionMapping, `${value}.imageStyle`, {}),
  });

  const getImageSrc = value =>
    _get(
      detectionMapping,
      `${value}.${isLandscape ? 'landscapeImage' : 'image'}`
    );

  if (activeDetection === 'skin_health') {
    return transformedSequenceOfCategory
      .filter(({value}) =>
        isHd
          ? [
              'hd_spot',
              'hd_oiliness',
              'hd_radiance',
              'hd_eye_bag',
              'hd_teartrough',
            ].includes(value)
          : value !== 'dark_circle'
      )
      .map(({value, disabled}) => {
        const imageSrc = getImageSrc(value);
        if (disabled || !imageSrc) return null;

        return (
          <img
            key={value}
            src={imageSrc}
            className={classnames({
              'skincaredetectionpreview-detections-mask__img': true,
              'skincaredetectionpreview-detections-mask__img--sd-landscape':
                !isHd && isLandscape,
            })}
            alt={value}
            style={getImageStyle(value)}
          />
        );
      });
  }

  const activeImageSrc = getImageSrc(activeDetection);

  return activeImageSrc ? (
    <img
      src={activeImageSrc}
      className={classnames({
        'skincaredetectionpreview-detections-mask__img': true,
        'skincaredetectionpreview-detections-mask__img--sd-landscape':
          !isHd && isLandscape,
      })}
      alt={activeDetection}
      style={getImageStyle(activeDetection)}
    />
  ) : null;
};

export default ConcernMaskEffect;
